import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGold"><Path d="M7 11.5L9 5.5H15L17 11.5H7Z" stroke="currentColor"/><Path d="M2 17.5L4 11.5H10L12 17.5H2Z" stroke="currentColor"/><Path d="M12 17.5L14 11.5H20L22 17.5H12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconGold;
